import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '上游新闻青少年心理健康服务平台';
const baseUrl = 'YGXQ0722';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/news`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'newsTypes',
      name: `${baseUrl}-newsTypes`,
      component: () => import('./pages/NewsTypes.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'hotLine',
      name: `${baseUrl}-hotLine`,
      component: () => import('./pages/HotLine.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'soulHotel',
      name: `${baseUrl}-soulHotel`,
      component: () => import('./pages/SoulHotel.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'messageLeave',
      name: `${baseUrl}-messageLeave`,
      component: () => import('./pages/MessageLeave.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'empty',
      name: `${baseUrl}-empty`,
      component: () => import('./pages/Empty.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
